import { render } from "./AccountantsCompanies.vue?vue&type=template&id=e351adf8"
import script from "./AccountantsCompanies.vue?vue&type=script&lang=js"
export * from "./AccountantsCompanies.vue?vue&type=script&lang=js"

import exportComponent from "/home/helder/SDD_2/Projetos/goldylocks-central-ui-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__